import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'vetrf-ui';
import { SubmenuMenuItem } from '../SubmenuItem/SubmenuItem';
import styles from '../../Sidebar.module.scss';

type MenuItemProps = {
  icon: string;
  title: string;
  isLarge: boolean;
  submenu: {
    link: string;
    title: string;
  }[];
  activeSubmenuItem: string;
  setActiveSubmenuItem: Dispatch<SetStateAction<string>>;
  onLinkClick?: (link: string) => void;
};

export const MenuItem = ({
  icon,
  title,
  submenu,
  isLarge,
  activeSubmenuItem,
  setActiveSubmenuItem,
  onLinkClick,
}: MenuItemProps) => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleSubmenuShowing = () => {
    setIsSubmenuOpen((prev) => !prev);
  };

  useEffect(() => {
    setIsSubmenuOpen(submenu.some((el) => el.link === activeSubmenuItem));
  }, [activeSubmenuItem]);

  const setCurrentOpenMenuBlock = (link: string) => {
    setActiveSubmenuItem(link);
  };

  if (isLarge) {
    return (
      <li
        onClick={toggleSubmenuShowing}
        key={title}
        className={classNames({
          [styles.active]: submenu.some((el) => el.link === activeSubmenuItem),
          [styles.submenuClosed]: activeSubmenuItem && !isSubmenuOpen,
        })}
      >
        <span className={styles.dropdownToggle}>
          <Icon color="grey" icon={icon} size={120} />
          <span className={styles.submenuTitle}>
            <span>{title}</span>
          </span>
          <b className="arrow fa fa-angle-down" />
        </span>
        <ul className={styles.submenu} style={{ display: isSubmenuOpen ? 'block' : 'none' }}>
          {submenu.map((submenuItem) => (
            <SubmenuMenuItem
              key={submenuItem.title}
              title={submenuItem.title}
              link={submenuItem.link}
              setCurrentOpenMenuBlock={setCurrentOpenMenuBlock}
              activeSubmenuItem={activeSubmenuItem}
              onLinkClick={onLinkClick}
            />
          ))}
        </ul>
      </li>
    );
  }

  return (
    <li
      key={title}
      className={classNames({
        [styles.active]: submenu.some((el) => el.link === activeSubmenuItem),
        [styles.min]: true,
      })}
    >
      <span className={styles.dropdownToggle}>
        <Icon color="grey" icon={icon} size={120} />
        <span className={styles.submenuTitle}>
          <span>{title}</span>
        </span>
      </span>
      <ul className={styles.submenu}>
        {/* fake text to match height margin */}
        <span className={styles.submenuTitle}>
          <span>{title}</span>
        </span>
        {submenu.map((submenuItem) => (
          <SubmenuMenuItem
            key={submenuItem.title}
            title={submenuItem.title}
            link={submenuItem.link}
            setCurrentOpenMenuBlock={setCurrentOpenMenuBlock}
            activeSubmenuItem={activeSubmenuItem}
            onLinkClick={onLinkClick}
          />
        ))}
      </ul>
    </li>
  );
};
